import React from "react";
import * as Sentry from "@sentry/react";

export const SentryTest: React.FC = () => {
  const throwTestError = (): void => {
    throw new Error("Sentry test route error");
  };

  const captureTestMessage = (): void => {
    Sentry.captureMessage("Sentry test route message", "info");
  };

  const captureTestException = (): void => {
    Sentry.captureException(new Error("Sentry test route captured exception"));
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        fontFamily: "Arial, sans-serif",
        background: "#f7f7f7",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "640px",
          background: "#ffffff",
          borderRadius: "12px",
          padding: "2rem",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
        }}
      >
        <h1 style={{ marginTop: 0 }}>Sentry Test Route</h1>
        <p style={{ color: "#444" }}>
          Use these actions to confirm browser events are reaching Sentry.
        </p>
        <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
          <button type="button" onClick={captureTestMessage}>
            Capture Message
          </button>
          <button type="button" onClick={captureTestException}>
            Capture Exception
          </button>
          <button type="button" onClick={throwTestError}>
            Throw Error
          </button>
        </div>
      </div>
    </div>
  );
};
